define((require) => {
    "use strict";

    var AnimationTypes               = require("shared/ui/experience/widgets/animations/AnimationTypes"),
        AnimationEditorTypes         = require("ui/experience/widgets/animations/AnimationEditorTypes"),
        EditorEvents                 = require("shared/services/EditorEvents"),
        template                     = require("ui/experience/widgets/animations/AnimationPropertiesView.tpl"),
        AbstractWidgetPropertiesView = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    var EXPAND_PROPERTY = "animationExpanded";

    /**
     * The animation properties view, containing the subviews for different animation types.
     *
     * @class AnimationPropertiesView
     *
     * @cfg {AbstractWidgetModel} model The widget model being edited.
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        template: template,

        regions: {
            slideAnimationProperties: ".slide-animation-properties",
            slideOutAnimationProperties: ".slide-out-animation-properties",
            fadeAnimationProperties: ".fade-animation-properties",
            fadeOutAnimationProperties: ".fade-out-animation-properties",
            zoomInAnimationProperties: ".zoom-in-animation-properties",
            zoomOutAnimationProperties: ".zoom-out-animation-properties",
            moveAnimationProperties: ".move-animation-properties"
        },

        ui: {
            container: ".animation-properties-accordion",
            legend: "[data-target=\".animation-properties-accordion\"]",
            slideAnimationEnabled: ".slide-animation-enabled",
            slideOutAnimationEnabled: ".slide-out-animation-enabled",
            fadeAnimationEnabled: ".fade-animation-enabled",
            fadeOutAnimationEnabled: ".fade-out-animation-enabled",
            zoomInAnimationEnabled: ".zoom-in-animation-enabled",
            zoomOutAnimationEnabled: ".zoom-out-animation-enabled",
            moveAnimationEnabled: ".move-animation-enabled"
        },

        events: {
            "change .slide-animation-enabled": function() {
                this._enabledChangeHandler(
                    AnimationTypes.SLIDE, this.ui.slideAnimationEnabled.is(":checked"),
                    this.slideAnimationProperties
                );
            },
            "change .slide-out-animation-enabled": function() {
                this._enabledChangeHandler(
                    AnimationTypes.SLIDE_OUT, this.ui.slideOutAnimationEnabled.is(":checked"),
                    this.slideOutAnimationProperties
                );
            },
            "change .fade-animation-enabled": function() {
                this._enabledChangeHandler(
                    AnimationTypes.FADE, this.ui.fadeAnimationEnabled.is(":checked"),
                    this.fadeAnimationProperties
                );
            },
            "change .fade-out-animation-enabled": function() {
                this._enabledChangeHandler(
                    AnimationTypes.FADE_OUT, this.ui.fadeOutAnimationEnabled.is(":checked"),
                    this.fadeOutAnimationProperties
                );
            },
            "change .zoom-in-animation-enabled": function() {
                this._enabledChangeHandler(
                    AnimationTypes.ZOOM_IN, this.ui.zoomInAnimationEnabled.is(":checked"),
                    this.zoomInAnimationProperties
                );
            },
            "change .zoom-out-animation-enabled": function() {
                this._enabledChangeHandler(
                    AnimationTypes.ZOOM_OUT, this.ui.zoomOutAnimationEnabled.is(":checked"),
                    this.zoomOutAnimationProperties
                );
            },
            "change .move-animation-enabled": function() {
                this._enabledChangeHandler(
                    AnimationTypes.MOVE, this.ui.moveAnimationEnabled.is(":checked"),
                    this.moveAnimationProperties
                );
            }
        },

        /**
         * Finds an animation in the animations collection with the given type.
         *
         * @param {Object} animationTypeDescriptor One of AnimationTypes.*
         * @returns {AnimationModel} The found model, or undefined if no match was found.
         * @private
         */
        _findAnimationWithType: function(animationTypeDescriptor) {
            return this.model.get("animations").find((model) => {
                return (animationTypeDescriptor.id === model.get("type"));
            });
        },

        /**
         * Handler for changes to the enabled state of a checkbox.
         *
         * @param {Object} animationTypeDescriptor The AnimationTypes.* object for the animation type.
         * @param {boolean} enabled The new enabled state.
         * @param {Object} propertiesViewRegion The region for the properties view.
         * @private
         */
        _enabledChangeHandler: function(animationTypeDescriptor, enabled, propertiesViewRegion) {
            var animationModel;

            if (enabled) {
                animationModel = new animationTypeDescriptor.modelClass();
                this.model.get("animations").add(animationModel);
                this._showPropertiesView(propertiesViewRegion, animationModel);
                propertiesViewRegion.$el.one("show.bs.collapse hide.bs.collapse shown.bs.collapse hidden.bs.collapse", (e) => {
                    e.stopPropagation();
                });
                propertiesViewRegion.$el.collapse("show");
            } else {
                animationModel = this._findAnimationWithType(animationTypeDescriptor);
                if (animationModel) {
                    this.model.get("animations").remove(animationModel);
                    animationModel.destroy();
                }
                propertiesViewRegion.$el.one("hidden", () => {
                    propertiesViewRegion.close();
                });
                propertiesViewRegion.$el.one("show.bs.collapse hide.bs.collapse shown.bs.collapse hidden.bs.collapse", (e) => {
                    e.stopPropagation();
                });
                propertiesViewRegion.$el.collapse("hide");
            }
            var viewModel = this.viewScope.viewModel,
                experience = viewModel.get("experience"),
                eventProperties = {
                    triggerOrigin: "WidgetMenuAnimationCheckbox",
                    updatedProperty: "animation-" + animationTypeDescriptor.id,
                    updatedValue: enabled,
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: viewModel.get("sceneNumber"),
                    widgetType: this.model.get("type")
                };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
        },

        /**
         * Shows the properties view for the given animation model in the given region.
         *
         * @param {Object} region The region.
         * @param {AnimationModel} model The model.
         * @private
         */
        _showPropertiesView: function(region, model) {
            region.show(new (AnimationEditorTypes.fromString(model.get("type")).propertiesViewClass)({
                model: model,
                widgetModel: this.model,
                widgetView: this.options.widgetView
            }));
        },

        onShow() {
            this.__super();
            const experience = this.viewScope.viewModel.get("experience");
            this.listenTo(experience, "change:emailModeEnabled", this._toggleAnimationBar);
        },

        _toggleAnimationBar() {
            const experience = this.viewScope.viewModel.get("experience");
            const isEmailModeEnabled = experience.get("emailModeEnabled");
            // close tab if expanded
            if (isEmailModeEnabled && this.ui.container.hasClass("in")) {
                this.ui.container.removeClass("in");
            }
            if (isEmailModeEnabled && !this.ui.legend.hasClass("collapsed")) {
                this.ui.legend.addClass("collapsed");
            }

            this.ui.legend.attr("data-toggle", isEmailModeEnabled ? "disabled" : "collapse");
        },

        onRender: function() {
            this.__super();
            this._toggleAnimationBar();

            var slideAnimationModel = this._findAnimationWithType(AnimationTypes.SLIDE),
                slideOutAnimationModel = this._findAnimationWithType(AnimationTypes.SLIDE_OUT),
                fadeAnimationModel = this._findAnimationWithType(AnimationTypes.FADE),
                fadeOutAnimationModel = this._findAnimationWithType(AnimationTypes.FADE_OUT),
                zoomInAnimationModel = this._findAnimationWithType(AnimationTypes.ZOOM_IN),
                zoomOutAnimationModel = this._findAnimationWithType(AnimationTypes.ZOOM_OUT),
                moveAnimationModel = this._findAnimationWithType(AnimationTypes.MOVE);

            if (slideAnimationModel) {
                this.ui.slideAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.slideAnimationProperties, slideAnimationModel);
                this.slideAnimationProperties.$el.addClass("in");
            }
            if (slideOutAnimationModel) {
                this.ui.slideOutAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.slideOutAnimationProperties, slideOutAnimationModel);
                this.slideOutAnimationProperties.$el.addClass("in");
            }
            if (fadeAnimationModel) {
                this.ui.fadeAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.fadeAnimationProperties, fadeAnimationModel);
                this.fadeAnimationProperties.$el.addClass("in");
            }
            if (fadeOutAnimationModel) {
                this.ui.fadeOutAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.fadeOutAnimationProperties, fadeOutAnimationModel);
                this.fadeOutAnimationProperties.$el.addClass("in");
            }
            if (zoomInAnimationModel) {
                this.ui.zoomInAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.zoomInAnimationProperties, zoomInAnimationModel);
                this.zoomInAnimationProperties.$el.addClass("in");
            }
            if (zoomOutAnimationModel) {
                this.ui.zoomOutAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.zoomOutAnimationProperties, zoomOutAnimationModel);
                this.zoomOutAnimationProperties.$el.addClass("in");
            }
            if (moveAnimationModel) {
                this.ui.moveAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.moveAnimationProperties, moveAnimationModel);
                this.moveAnimationProperties.$el.addClass("in");
            }
        }
    }, {
        expandProperty: EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/AnimationPropertiesView.js